<script setup>
import {defineEmits, onMounted, ref, toRefs, computed } from 'vue'
import { Select, SelectOption, defineProps  } from "ant-design-vue"

const emit = defineEmits(['changeValue'])
let tour = ref('');

const props = defineProps({
	value: {}
});
const {value} = toRefs(props);

const tourOptions = [
	{ value: '0', label: 'Отборочный тур' },
	{ value: '1', label: 'Лонг-лист' },
	{ value: '2', label: 'Шорт-лист' },
	{ value: '3', label: 'Победители' }
];

const tourLabel = computed(() => {
	const option = tourOptions.find(opt => opt.value == tour.value);
	return option ? option.label : '';
});

onMounted(() => {
	tour.value = value.value;
})

function changeValue(value) {
	emit('changeValue', value)
}

</script>

<template>
    <div style="margin-bottom: 20px;">
				<label style="display: block">Выберите тур конкурса</label>
				<Select v-model:value="tour" @change="changeValue" style="width: 300px">
					<SelectOption v-for="option in tourOptions" :key="option.value" :value="option.value">
						{{ option.label }}
					</SelectOption>
				</Select>
    </div>
</template>



<style lang="scss" scoped>

</style>